import { CheckoutActions } from '../actions';
import { CustomCheckoutState } from '../checkout-state';

export const initialState: CustomCheckoutState['orderDetails'] = {};

export function reducer(
  state = initialState,
  action: CheckoutActions.SetOrderDetails | CheckoutActions.ResetOrderDetails | CheckoutActions.ClearPlaceOrder,
): CustomCheckoutState['orderDetails'] {
  switch (action.type) {
    case CheckoutActions.SET_ORDER_DETAILS: {
      return action.payload;
    }

    case CheckoutActions.RESET_ORDER_DETAILS:
    case CheckoutActions.CLEAR_PLACE_ORDER: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
